import _animationFrame from './animationFrame';
import loadCss from './loadCss';
import loadJs from './loadJs';
import trim from './trim';
import wheelDirection from './wheelDirection';
import location from './location';

const animationFrame = (animate, fps = 60) => {
  return new _animationFrame(animate, fps);
};

export default {
  animationFrame,
  loadCss,
  loadJs,
  location,
  trim,
  wheelDirection
};
